import {DeliveryState} from "../../../type/delivery-state";

export const clearCachedDeliveriesDispatch = (state: DeliveryState) => {
    state.cachedUpdateDeliveries = [];
};
